import { getQueryParams } from './getQueryParams';
export const getQueryParam = key => {
  return getQueryParams()[key];
};